/** Own wheel/pinch input inside the diagram, leaving its surrounding page alone. */
export function bindWheelViewportGestures(element, onZoom) {
  let gestureScale = null;
  const consume = event => {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
  };
  const anchor = event => {
    const rect = element.getBoundingClientRect();
    return [Number.isFinite(event.clientX) ? event.clientX : rect.left + rect.width / 2,
      Number.isFinite(event.clientY) ? event.clientY : rect.top + rect.height / 2];
  };
  const wheel = event => {
    // Consume horizontal swipes and zoom-limit events too, so Safari cannot
    // hand the input back to page refresh/history navigation at a boundary.
    consume(event);
    if (gestureScale !== null || !Number.isFinite(event.deltaY) || event.deltaY === 0) return;
    const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? Math.max(1, element.clientHeight) : 1;
    const delta = Math.max(-240, Math.min(240, event.deltaY * unit));
    onZoom(Math.exp(-delta * 0.002), ...anchor(event));
  };
  const start = event => {
    consume(event);
    gestureScale = Number.isFinite(event.scale) && event.scale > 0 ? event.scale : 1;
  };
  const change = event => {
    consume(event);
    if (!Number.isFinite(event.scale) || event.scale <= 0) return;
    if (gestureScale !== null) onZoom(event.scale / gestureScale, ...anchor(event));
    gestureScale = event.scale;
  };
  const end = event => { consume(event); gestureScale = null; };
  const reset = () => { gestureScale = null; };
  const options = { passive: false };
  const listeners = [['wheel', wheel], ['gesturestart', start], ['gesturechange', change], ['gestureend', end]];
  for (const [type, handler] of listeners) element.addEventListener(type, handler, options);
  const ownerWindow = element.ownerDocument?.defaultView;
  ownerWindow?.addEventListener('blur', reset);
  ownerWindow?.addEventListener('gestureend', reset);
  return () => {
    for (const [type, handler] of listeners) element.removeEventListener(type, handler, options);
    ownerWindow?.removeEventListener('blur', reset);
    ownerWindow?.removeEventListener('gestureend', reset);
  };
}
